import React from 'react';
import {Table} from "reactstrap";


const sortTypes = {
    up: {
        class: 'sort-up',
    },
    down: {
        class: 'sort-down',
    },
    default: {
        class: 'sort',
    }
};

class NotWonTable extends React.Component {

    constructor(props) {
        super(props);
        this.formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'AUD',
        });
        this.state = {
            currentSort: 'default',
            sortField: ''
        }
    }

    onSortChange = (field) => {
        const { currentSort } = this.state;
        let nextSort;

        if (currentSort === 'down') nextSort = 'up';
        else if (currentSort === 'up') nextSort = 'default';
        else if (currentSort === 'default') nextSort = 'down';

        this.setState({
            currentSort: nextSort,
            sortField: field
        });
    };

    processData = () => {
        const {sortField, currentSort} = this.state;

        var ret = [];
        this.props.data.forEach(deal => {
            if (deal.DaysToSale >= this.props.view) {
                var rep = this.props.reps.filter(item => item.ExternalUserID == deal.UserID);
                var repName = 'Unknown';
                if (rep.length > 0) {
                    repName = rep[0].UserName;
                }
                ret.push({
                    Name: deal.DealTitle,
                    Value: deal.DealValue,
                    DealID: deal.DealID,
                    DaysOut: deal.DaysToSale,
                    RepName: repName
                })
            }
        });
        if (sortField === '') {
            ret.sort((a , b) => {
                return a.Value < b.Value ? 1 : (a.Value > b.Value ? -1 : 0);
            });
        } else {
            switch(currentSort) {
                case 'up':
                    ret.sort((a , b) => {
                        return a[sortField] < b[sortField] ? -1 : (a[sortField] > b[sortField] ? 1 : 0);
                    });
                    break;
                case 'down':
                    ret.sort((a , b) => {
                        return a[sortField] < b[sortField] ? 1 : (a[sortField] > b[sortField] ? -1 : 0);
                    });
                    break;
                default:
                    ret.sort((a , b) => {
                        return a.Value < b.Value ? 1 : (a.Value > b.Value ? -1 : 0);
                    });
                    break;
            }
        }

        return ret;
    }


    render() {
        const processed = this.processData();
        const { currentSort, sortField } = this.state;
        return (
            <>
                {processed.length > 0 &&
                    <Table
                        className="tablesorter"
                        responsive>
                        <thead
                            className="text-primary">
                        <tr>
                            <th>Deal
                                Name
                            </th>
                            <th
                                className={`sortable`}
                                onClick={() => this.onSortChange('RepName')}>
                                Rep &nbsp;
                                {
                                    sortField == 'RepName' && <i className={`fas fa-${sortTypes[currentSort].class}`} />
                                }
                                {
                                    sortField != 'RepName' && <i className={`fas fa-${sortTypes['default'].class}`} />
                                }
                            </th>
                            <th
                                onClick={() => this.onSortChange('Value')} className={`text-center sortable`}>
                                Value &nbsp;
                                {
                                    sortField == 'Value' && <i className={`fas fa-${sortTypes[currentSort].class}`} />
                                }
                                {
                                    sortField != 'Value' && <i className={`fas fa-${sortTypes['default'].class}`} />
                                }
                            </th>
                            <th className={`text-center`}>Link</th>
                            <th
                                onClick={() => this.onSortChange('DaysOut')} className={`text-center sortable`}>
                                Days &nbsp;
                                {
                                    sortField == 'DaysOut' && <i className={`fas fa-${sortTypes[currentSort].class}`} />
                                }
                                {
                                    sortField != 'DaysOut' && <i className={`fas fa-${sortTypes['default'].class}`} />
                                }
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            processed.map(i => {
                                return (
                                    <tr>
                                        <td>{i.Name}</td>
                                        <td>{i.RepName}</td>
                                        <td className={`text-center`}>{this.formatter.format(i.Value)}</td>
                                        <td className={`text-center`}>
                                            <a href={'https://instylesolar3.pipedrive.com/deal/' + i.DealID}>Link</a>
                                        </td>
                                        <td className={`text-center`}>{i.DaysOut}</td>
                                    </tr>
                                )
                            })
                        }


                        </tbody>
                    </Table>
                }
                {
                    processed.length == 0 &&
                        <div className={`text-center instyle-thumb-good`}>
                            <i className={`fa fa-thumbs-up`}></i>
                            <div>No Deals!</div>
                        </div>
                }
            </>
        )
    }
}

export default NotWonTable;